/*
 * Views for individual substitution group
 */

define([
  "marionette",
  "modules/substitutions/substitutionGroup/template/substitutionGroupTemplate.html",
], function (Marionette, SubstitutionGroupTemplate) {
  var SubstitutionGroupView = {};

  SubstitutionGroupView.substitutionGroupLayout = Marionette.Layout.extend({
    template: SubstitutionGroupTemplate,
    regions: {
      substitutionGroupInfo: "#substitutionGroupInfo",
      substitutionGroupEntries: "#substitutionGroupEntries",
    },
  });

  return SubstitutionGroupView;
});
